import axios from 'axios';
import { API_DOMAIN } from '../utils/constants';

export const getUserService = async () => {
  return await axios.get(`${API_DOMAIN}/user`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};
